import styled from 'styled-components'
import { Form } from '../../../../../../../../modules/Form/styled'

export const StyledForm = styled(Form)`
    max-width: 350px;
`

export const StyledSteps = styled.div``

export const StyledStepsHeader = styled.div`
    font-size: 15px;
    letter-spacing: 0.5px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.greyishBrown};
    margin-bottom: 25px;
`

export const StyledStepsItem = styled.div`
    margin-bottom: 25px;
    &:last-child {
        margin-bottom: 0;
    }
`

export const StyledStepName = styled.div`
    font-size: 14px;
    letter-spacing: 0.5px;
    font-weight: ${({ theme }) => theme.fontWeight.black};
    color: ${({ theme }) => theme.greyishBrown};
    margin-bottom: 5px;
`

export const StyledStepDesc = styled.div`
    font-size: 14px;
    letter-spacing: 0.5px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.greyishBrown};
    margin-left: 15px;
    margin-bottom: 20px;
`

export const StyledFormSelectWrapper = styled.div`
    margin-bottom: 16px;
`
export const StyledStepImage = styled.div`
    margin: 20px 0;
    text-align: center;
`
